import PropTypes from 'prop-types'
import { useState } from 'react'
import { Box, Button, Grid, TextField } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

import { useForm, Controller } from 'react-hook-form'
import useSnackbar from 'hooks/useSnackbar'

import { Card } from 'components'
import { LoadingFeedback, BackButton } from 'components'

import * as service from 'service'
import helpers from 'helpers'
import schema from './schema'
import { routes } from 'Routes'

const NAME_MAX_LENGTH = 255
const DESCRIPTION_MAX_LENGTH = 1000

const ChurnReasonForm = ({ isEdit, churnReason }) => {
  const [loading, setLoading] = useState(false)

  const history = useHistory()
  const snackbar = useSnackbar()

  const { control, handleSubmit, errors, watch } = useForm({
    validationSchema: schema(),
    defaultValues: {
      name: churnReason?.name || '',
      description: churnReason?.description || '',
    },
  })

  const name = watch('name')
  const description = watch('description')

  const handleReturn = () => history.push(routes.churnReasons.all)

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      if (isEdit) {
        await service.dponet.churnReasons.edit({
          churnReasonId: churnReason?.id,
          ...data,
        })
      } else {
        await service.dponet.churnReasons.create(data)
      }
      snackbar.open({
        message: `Motivo de churn ${
          isEdit ? 'editado' : 'criado'
        } com sucesso!`,
        variant: 'success',
      })
      handleReturn()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          `Erro ao ${isEdit ? 'editar' : 'criar'} motivo de churn!`,
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={loading} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Card title={`${isEdit ? 'Edição de' : 'Novo'} motivo`} paddingCard={2}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                as={
                  <TextField
                    label="Nome"
                    type="text"
                    color="primary"
                    variant="outlined"
                    error={!!errors.name}
                    helperText={
                      errors?.name?.message ||
                      `${name?.length || 0}/${NAME_MAX_LENGTH}`
                    }
                    inputProps={{ maxLength: NAME_MAX_LENGTH }}
                    fullWidth
                  />
                }
                control={control}
                name="name"
                mode="onBlur"
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                as={
                  <TextField
                    label="Descrição"
                    type="text"
                    color="primary"
                    variant="outlined"
                    multiline
                    rows={3}
                    error={!!errors.description}
                    helperText={
                      errors?.description?.message ||
                      `${description?.length || 0}/${DESCRIPTION_MAX_LENGTH}`
                    }
                    inputProps={{ maxLength: DESCRIPTION_MAX_LENGTH }}
                    fullWidth
                  />
                }
                control={control}
                name="description"
                mode="onBlur"
              />
            </Grid>
          </Grid>
        </Card>
        <Box display="flex" justifyContent="flex-end">
          <Box mr={2}>
            <Button
              color="primary"
              variant="outlined"
              type="button"
              onClick={handleReturn}
            >
              Voltar
            </Button>
          </Box>
          <Box>
            <Button color="primary" variant="contained" type="submit">
              Salvar
            </Button>
          </Box>
        </Box>
      </form>
    </>
  )
}

ChurnReasonForm.propTypes = {
  isEdit: PropTypes.bool,
  churnReason: PropTypes.object,
}

ChurnReasonForm.defaultProps = {
  isEdit: false,
  churnReason: null,
}

export default ChurnReasonForm
